"use strict";
'use client';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormCheckbox = void 0;
var _server = require("@whitbread-eos/utils/server");
var React = _interopRequireWildcard(require("react"));
var _index = require("../../Checkbox/index");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var FormCheckbox = exports.FormCheckbox = React.forwardRef((_ref, ref) => {
  var {
    className,
    labelClassName,
    name = 'defaultName',
    label,
    id,
    disabled = false,
    value,
    onChange,
    checkboxClassName
  } = _ref;
  return (0, _jsxRuntime.jsxs)("div", {
    ref: ref,
    className: (0, _server.cn)('flex items-center', className),
    children: [(0, _jsxRuntime.jsx)(_index.Checkbox, {
      id: id,
      checked: value,
      onCheckedChange: onChange,
      className: (0, _server.cn)(checkboxStyle, checkboxClassName),
      disabled: disabled,
      "data-testid": "".concat(id, "-Form-Checkbox"),
      "aria-checked": value,
      name: name
    }), (0, _jsxRuntime.jsx)("label", {
      htmlFor: id,
      className: (0, _server.cn)(labelStyle, labelClassName),
      "data-testid": "".concat(id, "-Label"),
      children: label
    })]
  });
});
FormCheckbox.displayName = 'FormCheckbox';
var checkboxStyle = 'w-5 h-5 border-lightGrey1 text-primaryColor';
var labelStyle = 'ml-3';